var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleCheckcomponent = function SvgCircleCheckcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14,
    r: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14c0-7.677-6.323-14-14-14C6.766 0 .5 6.323.5 14c0 7.734 6.266 14 14 14 7.677 0 14-6.266 14-14Zm-15.637 7.452c-.339.338-.96.338-1.298 0L5.694 15.58c-.34-.34-.34-.96 0-1.299l1.298-1.242a.799.799 0 0 1 1.242 0l4.008 3.952 8.468-8.468a.799.799 0 0 1 1.242 0l1.298 1.242c.339.339.339.96 0 1.299L12.863 21.452Z",
    fill: "current"
  })));
};
export default SvgCircleCheckcomponent;